import { Component, HostListener, Input } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { MenuItem } from '@data/common/MenuItem';
import { AccountDTO } from '@data/auth/AccountDTO';
import { ApplicationSelectors } from '@shared/store/application/application.selectors';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { LanguageVersion } from '@data/common/LanguageVersion';
import { ApplicationActions } from '@shared/store/application/application.actions';
import { AuthActions } from '@shared/store/auth/auth.actions';

@Component({
    selector: 'app-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    standalone: false
})
export class SideMenuComponent {
  public LanguageVersion: typeof LanguageVersion = LanguageVersion;

  public menuItems$: Observable<MenuItem[]> = this.store.select(ApplicationSelectors.menuItems);

  public language$: Observable<LanguageVersion> = this.store.select(ApplicationSelectors.language);

  @Input() public menuCollapse: boolean = false;

  @HostListener('click', [ '$event' ])
  public hostClicked(): void {
    event.stopPropagation();
  }

  constructor(private readonly store: Store) {

  }

  public changeLanguage(language: string): void {
    this.store.dispatch(new ApplicationActions.ChangeLanguage(language as LanguageVersion));
  }

  public logout(): void {
    this.store.dispatch(new AuthActions.Logout());
  }
}
